export enum RecognitionStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  NotYetApplied = 'not_yet_applied',
}
